import { createContext, useState, useEffect, useContext } from 'react';
import { getProducts, getCategories, getContent } from '../api/api';

const DataContext = createContext();

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within DataProvider');
  }
  return context;
};

export const DataProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadData = async () => {
    try {
      setLoading(true);
      const [productsData, categoriesData, contentData] = await Promise.all([
        getProducts(),
        getCategories(),
        getContent()
      ]);
      setProducts(productsData);
      setCategories(categoriesData);
      setContent(contentData);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Failed to load data:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const value = {
    products,
    categories,
    content,
    loading,
    error,
    refreshData: loadData
  };

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};
